import $ from 'jquery';
import axios from "axios";

$(function() {

    $('.product-item-slider .slider-images').slick({
        //autoplay: true,
        infinite: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        fade: true,
        arrows: false,
        dots: false,
        asNavFor: '.product-item-slider .slider-thumbnails',
        responsive: [
            // {
            //     breakpoint: 980,
            //     settings: {
            //         slidesToShow: 3,
            //         slidesToScroll: 1,
            //     }
            // },
            // {
            //     breakpoint: 600,
            //     settings: {
            //         slidesToShow: 1,
            //         slidesToScroll: 1,
            //         arrows: true,
            //     }
            // },
            // {
            //     breakpoint: 600,
            //     settings: {
            //         arrows: true,
            //     }
            // }
        ]
    });

    $('.product-item-slider .slider-thumbnails').slick({
        //infinite: true,
        slidesToShow: 4,
        slidesToScroll: 1,
        arrows: true,
        dots: false,
        //centerMode: true,
        focusOnSelect: true,
        asNavFor: '.product-item-slider .slider-images',
        responsive: [
            // {
            //     breakpoint: 980,
            //     settings: {
            //         slidesToShow: 3,
            //         slidesToScroll: 1,
            //     }
            // },
            // {
            //     breakpoint: 600,
            //     settings: {
            //         slidesToShow: 1,
            //         slidesToScroll: 1,
            //         arrows: true,
            //     }
            // },
            // {
            //     breakpoint: 600,
            //     settings: {
            //         arrows: true,
            //     }
            // }
        ]
    });

    $('.more h4').on('click', function() {
        let $more = $(this).closest('.more');
        let $content = $more.find('.content').first();
        $more.toggleClass('show');
        if ($more.hasClass('show')) {
            let height = $content.get(0).scrollHeight;
            console.log(height);
            $content.css('height', height + 'px');

            //$(this).closest('.content').animate({ height: $content.scrollHeight }, 500);
        } else {
            $content.css('height', 0);

            //$(this).closest('.content').animate({ height: 0}, 500);
        }

        //$(this).closest('.more').toggleClass('show');
        //$(this).closest('.content').animate({ height: $}, 500);;
        //$(this).closest('.content').animate({ height: 'toggle'}, 500);

    });

});
